import { createSelector } from 'reselect';

export const rateSelector = createSelector(
  (state) => state.workOrders.scenes.details.scenes.time.ui.rate,
  (rate) => {
    return rate;
  }
);

export const showAddModalSelector = createSelector(
  (state) => state.workOrders.scenes.details.scenes.time.ui.showAddModal,
  (showAddModal) => {
    return showAddModal;
  }
);

export const timeIdRateToEditSelector = createSelector(
  (state) => state.workOrders.scenes.details.scenes.time.ui.timeIdRateToEdit,
  (timeIdRateToEdit) => {
    return timeIdRateToEdit;
  }
);

export const timeSelector = createSelector(
  (state) => state.workOrders.scenes.details.scenes.time.data.time,
  (time) => {
    return time;
  }
);

export const timeToEditSelector = createSelector(
  (state) => state.workOrders.scenes.details.scenes.time.ui.timeToEdit,
  (timeToEdit) => {
    return timeToEdit;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/time/store/selectors.js